import React, {Fragment} from 'react';
import Box from '../layout/Box';
import TextInput from '../form/TextInput';
import TextArea from '../form/TextArea';
import createEditor, {referenceActionData} from '../form/ComponentEditor';
import SelectorGrid from "../form/SelectorGrid/SelectorGrid";
import classNames from "classnames";
import ComponentField from "../form/ComponentField";
import MembercardForm from "./forms/MembercardForm";
import MembercardList from "./lists/MembercardList";
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";
import Confirm from "../form/Confirm";

class MembercardEditor extends React.Component {

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        let saveButton = null;
        if (this.props.values.id && !parseInt(this.props.values.registered || "0") && this.props.values.user) {
            saveButton = <Confirm
                color="primary"
                header="Biztos hozzárendeled?"
                body="A kártya hozzárendelésével ez a felhasználó megkapja a kártyához tartozó össze tranzakciót és minden mást!"
                acceptButton="Mentés"
                className="pull-right"
                onAccept={this.saveForm}
            >
                Mentés
            </Confirm>;
        } else {
            saveButton = <Button
                key="0"
                disabled={!this.props.dirty || this.props.isLoading}
                color="primary"
                className="pull-right"
                onClick={this.saveForm}
            >
                Mentés
            </Button>;
        }
        return (
            <Fragment>
                <List
                    {...this.props}
                    loadForm={this.loadForm}
                    collapsed={this.props.collapsed || false}
                    theme="default"
                    header="Törzsvásárló kártyák"
                >
                    <MembercardList ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} />
                </List>
                <Editor
                    {...this.props}
                    loadForm={this.loadForm}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header="Törzsvásárló kártya"
                    footer={[
                        saveButton
                    ]}
                >
                    <MembercardForm {...this.props} loadForm={this.loadForm} />
                </Editor>
            </Fragment>
        );
    }
}
export default createEditor({
    componentName: "Membercard",
    WrappedComponent: MembercardEditor,
    props: {
        view: "admin"
    },
    componentActions: async (action, data, params, componentConfig) => {
        data = await referenceActionData(data, componentConfig);
        return {action, data, params};
    }
});

